/*
 * @Date: 2025-04-01 17:52:01
 * @Description:供应商订单管理
 */
import SupplierOrder from '../views/supplier-order.vue';
import OrderDetail from '../views/order-detail.vue';

import SupplierComprehensiveOrder from '../views/supplier-comprehensive-order.vue';
import ComprehensiveOrderDetail from '../views/comprehensive-order-detail.vue';

export const route = [
  /***************************************项目服务费订单*********************************************** */
  {
    path: '/main/supplier/order',
    name: 'supplier-order',
    meta: {
      title: '项目服务费订单'
    },
    component: SupplierOrder
  },
  /***************************************未完结订单详情*********************************************** */
  {
    path: '/main/supplier/order/detail',
    name: 'supplier-order-detail',
    meta: {
      title: '订单详情',
      parentPath: '/main/supplier/order'
    },
    component: OrderDetail
  },
  /***************************************综合服务费订单*********************************************** */
  {
    path: '/main/supplier/comprehensive-order',
    name: 'supplier-comprehensive-order',
    meta: {
      title: '综合服务费订单'
    },
    component: SupplierComprehensiveOrder
  },
  /***************************************综合服务费订单明细*********************************************** */
  {
    path: '/main/supplier/comprehensive-order/detail',
    name: 'supplier-comprehensive-order-detail',
    meta: {
      title: '综合服务费订单明细',
      parentPath: '/main/supplier/comprehensive-order'
    },
    component: ComprehensiveOrderDetail
  }
];
